import { render, staticRenderFns } from "./LECO_TrainingQuestionnaireAnswerResult.vue?vue&type=template&id=944ec28e&scoped=true&"
import script from "./LECO_TrainingQuestionnaireAnswerResult.vue?vue&type=script&lang=js&"
export * from "./LECO_TrainingQuestionnaireAnswerResult.vue?vue&type=script&lang=js&"
import style0 from "./LECO_TrainingQuestionnaireAnswerResult.vue?vue&type=style&index=0&id=944ec28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944ec28e",
  null
  
)

export default component.exports